"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapIconSizeRegistry = exports.BOOTSTRAP_FALLBACK_ICON = void 0;
const _composables_1 = require("../../_composables");
/**
 * The fallback icon that will be used if the `name` @Prop hasn't been defined
 */
exports.BOOTSTRAP_FALLBACK_ICON = 'icon-like';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.bootstrapIconSizeRegistry = {
    [_composables_1.SizeMap.Small]: '--small',
    [_composables_1.SizeMap.Medium]: '--medium',
    [_composables_1.SizeMap.Large]: '--large'
};
//# sourceMappingURL=Icon.config.js.map